import type { Middleware } from 'openapi-fetch';

/*
 * Request correlation (spec §4.5).
 * Stamps a client request id and an X-Amzn-Trace-Id so FE sessions correlate
 * with BFF X-Ray traces. No PII — ids only.
 */

function traceId(): string {
  const root = crypto.randomUUID().replace(/-/g, '').slice(0, 24);
  const epoch = Math.floor(Date.now() / 1000).toString(16);
  return `Root=1-${epoch}-${root}`;
}

export const requestIdMiddleware: Middleware = {
  onRequest({ request }) {
    request.headers.set('X-Request-Id', crypto.randomUUID());
    if (!request.headers.has('X-Amzn-Trace-Id')) {
      request.headers.set('X-Amzn-Trace-Id', traceId());
    }
    return request;
  },
};
